import { FC } from "react";
import { IconProps } from "./types";

export const SocialTwitter: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.123 5.272a7.077 7.077 0 0 1-2.24.855 3.528 3.528 0 0 0-6.011 3.218 10.013 10.013 0 0 1-7.27-3.685 3.508 3.508 0 0 0-.479 1.773c0 1.224.623 2.304 1.57 2.935a3.5 3.5 0 0 1-1.599-.44v.044a3.532 3.532 0 0 0 2.83 3.46 3.526 3.526 0 0 1-1.593.06 3.532 3.532 0 0 0 3.295 2.45 7.074 7.074 0 0 1-4.38 1.508c-.285 0-.565-.016-.843-.048a9.993 9.993 0 0 0 5.409 1.585c6.489 0 10.036-5.375 10.036-10.037 0-.153-.002-.305-.01-.456a7.147 7.147 0 0 0 1.76-1.826c-.631.281-1.312.47-2.025.555a3.542 3.542 0 0 0 1.55-1.951z"
      fill={fill}
    />
  </svg>
);
